<template>
  <div class="carousel-container">
    <!-- 轮播容器 -->
    <Swiper
      :modules="[Autoplay, Pagination, Navigation]"
      :autoplay="{ delay: 3000 }"
      loop="true"
      :pagination="{ clickable: true }"
      :navigation="true"
      class="swiper"
  :touchRatio="1"  
        :simulateTouch="true"  
    >
      <!-- 轮播图 -->
      <SwiperSlide v-for="(item, index) in props.carouselImages" :key="index">
        <img 
          :src="item.url" 
          :alt="item.alt" 
          class="slide-img"
          @click="CarouselPicToPageVideo(item)"
        >
      </SwiperSlide>

      <!-- 指示器和箭头插槽 -->
      <template #pagination>
        <div class="swiper-pagination"></div>
      </template>
      <template #navigation-prev>
        <div class="swiper-button-prev"></div>
      </template>
      <template #navigation-next>
        <div class="swiper-button-next"></div>
      </template>
    </Swiper>
  </div>
</template>

<script setup>
//import CarouselPicToVideoFromJson  from './data/CarouselPic.json'//这个是导入数据
//console.log("打印的是",CarouselPicToVideoFromJson)
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination, Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'


 import { useRouter } from 'vue-router'	
 const router = useRouter()//用于路由跳转


// 导航函数
const CarouselPicToPageVideo = (item) => {
  
  
  // 方式2: 使用Vue Router（如果在H5环境）
   router.push({
             path: '/to-singlevideo',
            query: {
                     name: item.name ,
                    title: item.title,
                 videosrc: item.videosrc
                    } 
           })
}

// 1. 接收父组件传递的轮播图数据
const props = defineProps({
  carouselImages: {
    type: Array,
    required: true,
    default: () => [] // 默认空数组避免报错
  }
})

</script>

<style scoped>
/* 核心：用padding-top固定16:9比例（16:9的高度 = 宽度 * 9/16 = 56.25%） */
.carousel-container {
  width: 100% !important;
  max-width: 1600px !important; /* 最大宽度限制（可选） */
  margin: 20px auto !important;
  background: red !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  position: relative !important; /* 关键：让子元素可以绝对定位 */
}

/* 用伪元素撑开16:9比例（核心逻辑） */
.carousel-container::after {
  content: '' !important;
  display: block !important;
  padding-top: 56.25% !important; /* 16:9 = 9/16 = 56.25% */
}

/* 轮播容器绝对定位，填充父容器的16:9区域 */
.swiper {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

/* 图片完全按16:9比例显示（不变形、不裁剪） */
.slide-img {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important; /* 完整显示图片，空白处显示红色背景 */
  /* 如果图片本身不是16:9，可用object-fit: cover裁剪多余部分（但会变形） */
  /* object-fit: cover !important; */
}

/* 指示器和箭头样式 */
:deep(.swiper-pagination-bullet) {
  width: 12px;
  height: 12px;
  background: rgba(0,255,0,1);
  margin: 0 8px;
  opacity: 1
}
:deep(.swiper-pagination-bullet-active) {
  width: 30px;
  border-radius: 6px;
  background: white;
}

:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
  width: 50px;
  height: 50px;
  background: rgba(0,0,0,0.3);
  border-radius: 50%;
  color: white;
}

/* 移动端优化（保持16:9比例，仅缩小控件） */
@media (max-width: 768px) {
  :deep(.swiper-pagination-bullet) {
    width: 8px;
    height: 8px;
    margin: 0 5px;
  }
  :deep(.swiper-pagination-bullet-active) {
    width: 20px;
  }
  :deep(.swiper-button-prev),
  :deep(.swiper-button-next) {
    width: 36px;
    height: 36px;
  }
  
}
/* 电脑端专属：控制轮播图大小（屏幕≥1024px时生效） */
@media (min-width: 1024px) {
  /* 限制中间显示区宽度为手机竖屏常见宽度（如375px，可修改） */
  .carousel-container {
    max-width: 500px !important; /* 中间显示区宽度（手机常见宽度） */
    margin: 20px auto !important; /* 左右自动留白，居中显示 */
  }
}

</style>
    